import { Icon } from '@iconify/react'
import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import { RaspadinhaWinnersTable } from '@/components/RaspadinhaWinnersTable'
import editStyles from '../CampanhasPage/CampanhaEditPage.module.css'
import styles from './RaspadinhaGanhadoresSection.module.css'

type RaspadinhaGanhadoresSectionProps = {
  form: RaspadinhaCampaign
}

export function RaspadinhaGanhadoresSection({ form }: RaspadinhaGanhadoresSectionProps) {
  return (
    <section className={editStyles.editSection} aria-labelledby="raspadinha-ganhadores">
      <div className={styles.sectionHeaderWithAction}>
        <h2
          id="raspadinha-ganhadores"
          className={`${editStyles.editSectionTitle} ${styles.sectionHeaderTitle}`}
        >
          <Icon className={editStyles.editSectionTitleIcon} icon="mdi:account-group-outline" />
          Ganhadores
        </h2>
      </div>

      <div className={editStyles.editSectionBody}>
        <RaspadinhaWinnersTable
          winning_date_schedules={form.winning_date_schedules}
          participants={form.participants}
          slug={form.slug}
        />
      </div>
    </section>
  )
}
